import React from "react";
import { FormattedMessage } from "react-intl";
import { useTheme } from "styled-components";
import { DayOfWeek } from "../../domain/orchestrationCriteria.entity";
import {
  criteriaModalMessages as messages,
  useDayOfWeekLabels,
} from "../../../orchestrator.messages";
import { WindowFormValue } from "../../utils/criteriaWindow.helpers";

interface DayOfWeekInputProps {
  windows: WindowFormValue[];
  setWindows: React.Dispatch<React.SetStateAction<WindowFormValue[]>>;
  onDayToggle: (windowId: string, day: DayOfWeek) => void;
}

export function DayOfWeekInput({ windows, setWindows, onDayToggle }: DayOfWeekInputProps) {
  const theme = useTheme();
  const dayOfWeekLabels = useDayOfWeekLabels();

  return (
    <div>
      <label className="block font-medium text-gray-700 mb-2">
        <FormattedMessage {...messages.activeDays} />
      </label>
      <div className="text-gray-500 text-xs my-2">
        <FormattedMessage {...messages.noDaysSelectedHelper} />
      </div>
      {windows.length > 0 && (
        <>
          <div className="flex gap-2 mb-2">
            <button
              type="button"
              onClick={() =>
                setWindows(prev =>
                  prev.map((w, i) => (i === 0 ? { ...w, activeDays: Object.values(DayOfWeek) } : w))
                )
              }
              className="text-sm text-blue-600 hover:text-blue-800 hover:underline">
              <FormattedMessage {...messages.selectAll} />
            </button>
            <span className="text-gray-300">|</span>
            <button
              type="button"
              onClick={() =>
                setWindows(prev => prev.map((w, i) => (i === 0 ? { ...w, activeDays: [] } : w)))
              }
              className="text-sm text-blue-600 hover:text-blue-800 hover:underline">
              <FormattedMessage {...messages.deselectAll} />
            </button>
          </div>
          <div className="flex flex-wrap gap-2">
            {Object.values(DayOfWeek).map(day => (
              <label
                key={day}
                className={`px-3 py-1 rounded border cursor-pointer text-sm ${
                  windows[0].activeDays.includes(day)
                    ? `bg-[${theme.textColor}] text-white border-[${theme.textColor}]`
                    : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                }`}>
                <input
                  type="checkbox"
                  checked={windows[0].activeDays.includes(day)}
                  onChange={() => onDayToggle(windows[0].id, day)}
                  className="sr-only"
                />
                {dayOfWeekLabels[day]}
              </label>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
